module.exports = __webpack_public_path__ + "static/media/VG.557981c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/VG.svg
// module id = 389
// module chunks = 0